import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import './team.css';
import u1 from './assets/u1.png';
import u2 from './assets/u21.png';
import { Container,Icon,Grid,Card,Image,Popup,Button } from 'semantic-ui-react';

class Team extends React.Component{
    render(){
        return(
            <Container>
                <Grid columns={2} stackable className="team-grid">
                    <Grid.Row className="team-row">
                        <Grid.Column className="team-column">
                        <Card>
                            <Popup
                                open
                                trigger={<Image src={u1} wrapped ui={false} />}
                                content="😇  follow for more cool stuff, or to chat"
                                position='top left'
                            />
                            <Card.Content>
                            <Card.Header>Abhishek Vyas</Card.Header>
                            <Card.Description>
                                Co-Founder & CTO
                            </Card.Description>
                            </Card.Content>
                            <Card.Content extra>
                            <a href="https://twitter.com/Abhishe72905906" target="_blank" rel="noreferrer">
                                <Button color='twitter' size="medium">
                                    <Icon name='twitter' /> Twitter
                                </Button>
                            </a>
                            <a href="https://www.linkedin.com/in/abhishek-vya5" target="_blank" rel="noreferrer">
                                <Button color='linkedin' size="medium">
                                    <Icon name='linkedin' /> LinkedIn
                                </Button>
                            </a>
                            </Card.Content>
                        </Card>
                        </Grid.Column>
                        <Grid.Column className="team-column">
                        <Card>
                            <Popup
                                open
                                trigger={<Image src={u2} wrapped ui={false} />}
                                content="Get in touch to chat  😉"
                                position='top right'
                            />
                            <Card.Content>
                            <Card.Header>Prithviraj Musmade</Card.Header>
                            <Card.Description>
                                Co-Founder & COO
                            </Card.Description>
                            </Card.Content>
                            <Card.Content extra>
                            <a href="https://www.linkedin.com/in/thedrdoom404/" target="_blank" rel="noreferrer">
                                <Button color='linkedin' size="medium">
                                    <Icon name='linkedin' /> LinkedIn
                                </Button>
                            </a>
                            </Card.Content>
                        </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

export default Team;